import { HStack } from '@chakra-ui/react';
import { PlaceCardData } from './components/PlaceCardData';
import { Database } from '@habity/types';
import { getMapsUrl } from '@habity/utils';

type Place = Database['public']['Tables']['places']['Row'];

interface PlaceCardProps {
  place: Place;
  isLoading?: boolean;
  variant?: 'default' | 'compact';
}

export const PlaceCard = ({
  place,
  isLoading = false,
  variant = 'default',
}: PlaceCardProps) => {
  const { street, zip, city } = place || {};
  return (
    <HStack
      cursor={isLoading ? 'default' : 'pointer'}
      borderLeftColor="blackAlpha.200"
      borderLeftWidth="1px"
      className="group"
      _hover={{
        backgroundColor: 'blackAlpha.50',
        borderLeftColor: 'burntOrange',
      }}
      onClick={() => window?.open(getMapsUrl({ street, zip, city }))}
    >
      <PlaceCardData place={place} isLoading={isLoading} variant={variant} />
    </HStack>
  );
};
